/**
 * MODULO DI FORMATTAZIONE EXCEL - VERSIONE CON COLONNE TOTALI + ORE NOTTURNE
 *
 * Struttura:
 * - Riga 1: Vuota
 * - Riga 2: Titolo azienda (merge B2:M2+)
 * - Riga 3: Vuota
 * - Poi per OGNI dipendente: blocco di 6 righe
 *   - Riga 1 del blocco: Giorno | Giorni settimana (Sa, Lu, Ma...)
 *   - Riga 2 del blocco: N. | Cognome/Nome | | Numeri giorni (1, 2, 3...) | GG | [totale giorni]
 *   - Riga 3 del blocco: [N.prog] | Cognome | ORE | [ore lavorate] | ORE | [totale ore standard]
 *   - Riga 4 del blocco: | Nome | Straordinario | [ore straord.] | ORE | [totale ore straord.]
 *   - Riga 5 del blocco: | | C.I. | [cassa integrazione] | TOT | [totale ore std+straord]
 *   - Riga 6 del blocco: | | NOTTE | [ore notturne evidenziate in blu] | ASS | [giorni assenza] | NOTTE | [totale ore notte]
 */

export const ExcelFormattingTemplate = {

  // STILI PER IL TITOLO AZIENDA (Riga 2)
  titoloAzienda: {
    font: {
      name: 'Arial Black',
      sz: 36,
      bold: true,
      color: { rgb: 'FFFFFF' }
    },
    fill: {
      fgColor: { rgb: 'FF0000' }
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    }
  },

  // STILI PER "Giorno" (prima riga di ogni blocco)
  labelGiorno: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: false
    },
    alignment: {
      horizontal: 'left',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // STILI PER I GIORNI DELLA SETTIMANA
  giorniSettimana: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // STILI PER I WEEKEND (Sabato e Domenica)
  giorniWeekend: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true,
      color: { rgb: 'FFFFFF' }
    },
    fill: {
      fgColor: { rgb: 'FF0000' }
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // STILI PER GLI HEADERS
  headerNumero: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin',   color: { rgb: '000000' } },
      bottom: { style: 'medium', color: { rgb: '000000' } },
      left:   { style: 'medium', color: { rgb: '000000' } },
      right:  { style: 'thin',   color: { rgb: '000000' } }
    }
  },

  headerCognomeNome: {
    font: {
      name: 'Tahoma',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin',   color: { rgb: '000000' } },
      bottom: { style: 'medium', color: { rgb: '000000' } },
      left:   { style: 'thin',   color: { rgb: '000000' } },
      right:  { style: 'thin',   color: { rgb: '000000' } }
    }
  },

  headerNumeroGiorno: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin',   color: { rgb: '000000' } },
      bottom: { style: 'medium', color: { rgb: '000000' } },
      left:   { style: 'thin',   color: { rgb: '000000' } },
      right:  { style: 'thin',   color: { rgb: '000000' } }
    }
  },

  // STILI PER LE RIGHE DATI
  numeroProgressivo: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'medium', color: { rgb: '000000' } },
      bottom: { style: 'thin',   color: { rgb: '000000' } },
      left:   { style: 'medium', color: { rgb: '000000' } },
      right:  { style: 'medium', color: { rgb: '000000' } }
    }
  },

  cognome: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'left',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  nome: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: false
    },
    alignment: {
      horizontal: 'left',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  labelRiga: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // 🌙 STILE LABEL RIGA NOTTE (testo bianco su sfondo blu scuro)
  labelRigaNotte: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true,
      color: { rgb: 'FFFFFF' }
    },
    fill: {
      fgColor: { rgb: '1A237E' }
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  valoreGiornata: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // 🌙 STILE VALORE GIORNATA NOTTURNA (sfondo blu scuro, testo bianco)
  valoreGiornataNotturna: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true,
      color: { rgb: 'FFFFFF' }
    },
    fill: {
      fgColor: { rgb: '1A237E' }
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // STILE PER CELLE VUOTE (con bordi)
  cellaVuota: {
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // STILI PER LE COLONNE TOTALI
  labelTotale: {
    font: {
      name: 'Arial',
      sz: 12,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  valoreTotale: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // 🌙 STILE TOTALE ORE NOTTE (sfondo blu scuro)
  valoreTotaleNotte: {
    font: {
      name: 'Arial',
      sz: 14,
      bold: true,
      color: { rgb: 'FFFFFF' }
    },
    fill: {
      fgColor: { rgb: '1A237E' }
    },
    alignment: {
      horizontal: 'center',
      vertical: 'center'
    },
    border: {
      top:    { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
      left:   { style: 'thin', color: { rgb: '000000' } },
      right:  { style: 'thin', color: { rgb: '000000' } }
    }
  },

  // LARGHEZZE COLONNE
  columnWidths: {
    A: 8.43,       // N. progressivo
    B: 32.0,       // Cognome/Nome
    C: 9.71,       // ORE/Straordinario/C.I./NOTTE
    day: 5.86,     // Ogni giorno del mese
    labelTotal: 6.0,   // Colonna label totale (GG, ORE, TOT, ASS, NOTTE)
    valueTotal: 8.0    // Colonna valore totale
  }
};

// =====================================================================
// HELPERS PRIVATI
// =====================================================================

/**
 * Crea una cella con stile per XLSX
 */
const createStyledCell = (value, style) => {
  return {
    v: value,
    t: typeof value === 'number' ? 'n' : 's',
    s: style
  };
};

/**
 * Converte un numero di colonna (1-based) nella lettera corrispondente (A, B, ..., AA, AB, ...)
 */
const getColumnLetter = (colNumber) => {
  let letter = '';
  while (colNumber > 0) {
    const remainder = (colNumber - 1) % 26;
    letter = String.fromCharCode(65 + remainder) + letter;
    colNumber = Math.floor((colNumber - 1) / 26);
  }
  return letter;
};

/**
 * Verifica se una data è festiva
 */
const isHoliday = (dateStr, holidays) => {
  return holidays.includes(dateStr);
};

/**
 * Verifica se una data è weekend
 */
const isWeekend = (dateObj) => {
  const day = dateObj.getDay();
  return day === 0 || day === 6;
};

/**
 * Calcola i totali di un dipendente per il mese
 * Restituisce: giorniLavorativi, oreStandard, oreStraordinarie, oreTotali, giorniAssenza, oreNotte
 */
const calculateEmployeeTotals = (employee, daysInMonth, month, year, holidays) => {
  let totGiorniLavorativi = 0;
  let totOreStandard      = 0;
  let totOreStraordinarie = 0;
  let totOreNotte         = 0;  // 🌙 NUOVO
  let giorniAssenza       = 0;

  for (let day = 1; day <= daysInMonth; day++) {
    const date    = new Date(year, month - 1, day);
    const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

    const isWeekendDay  = isWeekend(date);
    const isHolidayDay  = isHoliday(dateStr, holidays);

    const dayData = employee.reportData.find(d => new Date(d.date).getDate() === day);

    if (dayData) {
      const standardValue  = dayData.standard;
      const overtimeValue  = dayData.overtime  || 0;
      const nightValue     = dayData.nightHours || 0;  // 🌙 NUOVO
      const standardStr    = String(standardValue).trim().toUpperCase();
      const isSpecialChar  = ['C.I.', 'P', 'F', 'M', 'C', 'CIG', 'A'].includes(standardStr);

      // Ore standard
      if (!isSpecialChar && !isNaN(parseFloat(standardValue)) && parseFloat(standardValue) > 0) {
        totGiorniLavorativi++;
        totOreStandard += parseFloat(standardValue);
      }

      // Ore straordinarie
      if (!isNaN(parseFloat(overtimeValue)) && parseFloat(overtimeValue) > 0) {
        totOreStraordinarie += parseFloat(overtimeValue);
      }

      // 🌙 Ore notturne
      if (!isNaN(parseFloat(nightValue)) && parseFloat(nightValue) > 0) {
        totOreNotte += parseFloat(nightValue);
      }

      // Conteggio assenze (giorni feriali senza ore e senza lettere speciali)
      if (!isWeekendDay && !isHolidayDay) {
        const hasNoHours =
          (!standardValue || (isNaN(parseFloat(standardValue)) && !isSpecialChar)) &&
          (!overtimeValue  || isNaN(parseFloat(overtimeValue)));
        if (hasNoHours || (parseFloat(standardValue) === 0 && parseFloat(overtimeValue) === 0)) {
          giorniAssenza++;
        }
      }
    } else {
      // Giorno senza dati → assenza se feriale
      if (!isWeekendDay && !isHolidayDay) {
        giorniAssenza++;
      }
    }
  }

  return {
    giorniLavorativi: totGiorniLavorativi,
    oreStandard:      totOreStandard,
    oreStraordinarie: totOreStraordinarie,
    oreTotali:        totOreStandard + totOreStraordinarie,
    oreNotte:         Math.round(totOreNotte * 10) / 10,  // 🌙 NUOVO
    giorniAssenza:    giorniAssenza
  };
};

// =====================================================================
// FUNZIONE PRINCIPALE
// =====================================================================

/**
 * Applica il template al foglio PRESENZE del workbook Excel
 *
 * @param {object}   XLSX        - Libreria SheetJS
 * @param {object}   workbook    - Workbook XLSX
 * @param {string}   sheetName   - Nome del foglio
 * @param {string}   companyName - Nome azienda da mostrare nel titolo
 * @param {number}   month       - Mese (1-12)
 * @param {number}   year        - Anno (es. 2025)
 * @param {Array}    reportData  - Array di report dipendenti
 * @returns {object|null}        - Oggetto sheet XLSX o null in caso di errore
 */
export const applyTemplateToSummarySheet = (XLSX, workbook, sheetName, companyName, month, year, reportData) => {
  if (!XLSX || !XLSX.utils) {
    console.error('XLSX non disponibile o non valido');
    return null;
  }

  const sheet      = {};
  let   currentRow = 1;

  const daysInMonth = new Date(year, month, 0).getDate();
  const dayNames    = ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'];

  const holidays = [
    '2024-01-01', '2024-01-06', '2024-04-01', '2024-04-25', '2024-05-01',
    '2024-06-02', '2024-08-15', '2024-11-01', '2024-12-08', '2024-12-25', '2024-12-26',
    '2025-01-01', '2025-01-06', '2025-04-20', '2025-04-21', '2025-04-25', '2025-05-01',
    '2025-06-02', '2025-08-15', '2025-11-01', '2025-12-08', '2025-12-25', '2025-12-26',
    '2026-01-01', '2026-01-06', '2026-04-05', '2026-04-06', '2026-04-25', '2026-05-01',
    '2026-06-02', '2026-08-15', '2026-11-01', '2026-12-08', '2026-12-25', '2026-12-26'
  ];

  if (!sheet['!merges']) sheet['!merges'] = [];

  // ------------------------------------------------------------------
  // RIGA 1: VUOTA
  // ------------------------------------------------------------------
  currentRow++;

  // ------------------------------------------------------------------
  // RIGA 2: TITOLO AZIENDA
  // ------------------------------------------------------------------
  const lastColWithTotals = 3 + daysInMonth + 2; // colonne A,B,C + giorni + 2 totali
  sheet[`B${currentRow}`] = createStyledCell(
    companyName || 'FD SRL',
    ExcelFormattingTemplate.titoloAzienda
  );
  sheet['!merges'].push({
    s: { r: currentRow - 1, c: 1 },
    e: { r: currentRow - 1, c: lastColWithTotals - 1 }
  });
  currentRow++;

  // ------------------------------------------------------------------
  // RIGA 3: VUOTA
  // ------------------------------------------------------------------
  currentRow++;

  // ------------------------------------------------------------------
  // CICLO DIPENDENTI
  // ------------------------------------------------------------------
  reportData.forEach((employee, empIndex) => {

    const totals = calculateEmployeeTotals(employee, daysInMonth, month, year, holidays);

    // Colonne totali (ultime 2)
    const colLabel1 = getColumnLetter(3 + daysInMonth + 1);
    const colValue1 = getColumnLetter(3 + daysInMonth + 2);

    // ----------------------------------------------------------------
    // RIGA 1 DEL BLOCCO — Giorno | Giorni settimana
    // ----------------------------------------------------------------
    sheet[`A${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`B${currentRow}`] = createStyledCell('Giorno', ExcelFormattingTemplate.labelGiorno);
    sheet[`C${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);

    for (let day = 1; day <= daysInMonth; day++) {
      const date       = new Date(year, month - 1, day);
      const dayOfWeek  = date.getDay();
      const col        = getColumnLetter(3 + day);
      const isWknd     = dayOfWeek === 0 || dayOfWeek === 6;
      const dayStyle   = isWknd
        ? ExcelFormattingTemplate.giorniWeekend
        : ExcelFormattingTemplate.giorniSettimana;
      sheet[`${col}${currentRow}`] = createStyledCell(dayNames[dayOfWeek], dayStyle);
    }

    sheet[`${colLabel1}${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`${colValue1}${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    currentRow++;

    // ----------------------------------------------------------------
    // RIGA 2 DEL BLOCCO — N. | Cognome/Nome | | Numeri giorni | GG | [gg lavorativi]
    // ----------------------------------------------------------------
    sheet[`A${currentRow}`] = createStyledCell('N.',           ExcelFormattingTemplate.headerNumero);
    sheet[`B${currentRow}`] = createStyledCell('Cognome/Nome', ExcelFormattingTemplate.headerCognomeNome);
    sheet[`C${currentRow}`] = createStyledCell('',             ExcelFormattingTemplate.cellaVuota);

    for (let day = 1; day <= daysInMonth; day++) {
      const col = getColumnLetter(3 + day);
      sheet[`${col}${currentRow}`] = createStyledCell(day, ExcelFormattingTemplate.headerNumeroGiorno);
    }

    sheet[`${colLabel1}${currentRow}`] = createStyledCell('GG',                    ExcelFormattingTemplate.labelTotale);
    sheet[`${colValue1}${currentRow}`] = createStyledCell(totals.giorniLavorativi, ExcelFormattingTemplate.valoreTotale);
    currentRow++;

    // Merge colonna A per le 4 righe dati (ORE → NOTTE)
    sheet['!merges'].push({
      s: { r: currentRow - 1, c: 0 },
      e: { r: currentRow + 2,  c: 0 }
    });

    // ----------------------------------------------------------------
    // RIGA 3 DEL BLOCCO — [N] | Cognome | ORE | [ore standard] | ORE | [tot std]
    // ----------------------------------------------------------------
    const employeeNumber = empIndex + 1;
    const cognome = employee.cognome || employee.userName.split(' ')[0] || employee.userName;
    const nome    = employee.nome    || employee.userName.split(' ').slice(1).join(' ') || '';

    sheet[`A${currentRow}`] = createStyledCell(employeeNumber,              ExcelFormattingTemplate.numeroProgressivo);
    sheet[`B${currentRow}`] = createStyledCell(cognome || employee.userName, ExcelFormattingTemplate.cognome);
    sheet[`C${currentRow}`] = createStyledCell('ORE',                        ExcelFormattingTemplate.labelRiga);

    for (let day = 1; day <= daysInMonth; day++) {
      const col     = getColumnLetter(3 + day);
      const dayData = employee.reportData.find(d => new Date(d.date).getDate() === day);
      const val     = dayData && dayData.standard && dayData.standard > 0 ? dayData.standard : '';
      sheet[`${col}${currentRow}`] = createStyledCell(val, ExcelFormattingTemplate.valoreGiornata);
    }

    sheet[`${colLabel1}${currentRow}`] = createStyledCell('ORE',              ExcelFormattingTemplate.labelTotale);
    sheet[`${colValue1}${currentRow}`] = createStyledCell(totals.oreStandard, ExcelFormattingTemplate.valoreTotale);
    currentRow++;

    // ----------------------------------------------------------------
    // RIGA 4 DEL BLOCCO — | Nome | Straordinario | [ore straord.] | ORE | [tot straord]
    // ----------------------------------------------------------------
    sheet[`A${currentRow}`] = createStyledCell('',            ExcelFormattingTemplate.cellaVuota);
    sheet[`B${currentRow}`] = createStyledCell(nome || '',    ExcelFormattingTemplate.nome);
    sheet[`C${currentRow}`] = createStyledCell('Straordinario', ExcelFormattingTemplate.labelRiga);

    for (let day = 1; day <= daysInMonth; day++) {
      const col     = getColumnLetter(3 + day);
      const dayData = employee.reportData.find(d => new Date(d.date).getDate() === day);
      const val     = dayData && dayData.overtime && dayData.overtime > 0 ? dayData.overtime : '';
      sheet[`${col}${currentRow}`] = createStyledCell(val, ExcelFormattingTemplate.valoreGiornata);
    }

    sheet[`${colLabel1}${currentRow}`] = createStyledCell('ORE',                  ExcelFormattingTemplate.labelTotale);
    sheet[`${colValue1}${currentRow}`] = createStyledCell(totals.oreStraordinarie, ExcelFormattingTemplate.valoreTotale);
    currentRow++;

    // ----------------------------------------------------------------
    // RIGA 5 DEL BLOCCO — | | C.I. | [celle vuote] | TOT | [tot std+straord]
    // ----------------------------------------------------------------
    sheet[`A${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`B${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`C${currentRow}`] = createStyledCell('C.I.', ExcelFormattingTemplate.labelRiga);

    for (let day = 1; day <= daysInMonth; day++) {
      const col = getColumnLetter(3 + day);
      sheet[`${col}${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.valoreGiornata);
    }

    sheet[`${colLabel1}${currentRow}`] = createStyledCell('TOT',            ExcelFormattingTemplate.labelTotale);
    sheet[`${colValue1}${currentRow}`] = createStyledCell(totals.oreTotali, ExcelFormattingTemplate.valoreTotale);
    currentRow++;

    // ----------------------------------------------------------------
    // RIGA 6 DEL BLOCCO — | | NOTTE | [ore notturne in blu] | ASS | [assenze] | NOTTE | [tot notte]
    // 🌙 Celle con ore notturne > 0 vengono evidenziate in blu scuro
    // ----------------------------------------------------------------
    sheet[`A${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`B${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.cellaVuota);
    sheet[`C${currentRow}`] = createStyledCell('NOTTE', ExcelFormattingTemplate.labelRigaNotte);

    for (let day = 1; day <= daysInMonth; day++) {
      const col     = getColumnLetter(3 + day);
      const dayData = employee.reportData.find(d => new Date(d.date).getDate() === day);
      const nightH  = dayData && dayData.nightHours && parseFloat(dayData.nightHours) > 0
        ? parseFloat(dayData.nightHours)
        : 0;

      if (nightH > 0) {
        // 🌙 Evidenzia in blu le giornate con turno notturno
        sheet[`${col}${currentRow}`] = createStyledCell(nightH, ExcelFormattingTemplate.valoreGiornataNotturna);
      } else {
        sheet[`${col}${currentRow}`] = createStyledCell('', ExcelFormattingTemplate.valoreGiornata);
      }
    }

    // Colonna totali riga NOTTE: ASS (giorni assenza) + NOTTE (totale ore notturne)
    sheet[`${colLabel1}${currentRow}`] = createStyledCell('ASS',              ExcelFormattingTemplate.labelTotale);
    sheet[`${colValue1}${currentRow}`] = createStyledCell(totals.giorniAssenza, ExcelFormattingTemplate.valoreTotale);
    currentRow++;

  }); // fine forEach dipendenti

  // ------------------------------------------------------------------
  // RANGE E LARGHEZZE COLONNE
  // ------------------------------------------------------------------
  const lastRow       = currentRow - 1;
  const lastColLetter = getColumnLetter(lastColWithTotals);
  sheet['!ref'] = `A1:${lastColLetter}${lastRow}`;

  sheet['!cols'] = [
    { wch: ExcelFormattingTemplate.columnWidths.A },
    { wch: ExcelFormattingTemplate.columnWidths.B },
    { wch: ExcelFormattingTemplate.columnWidths.C }
  ];

  for (let i = 0; i < daysInMonth; i++) {
    sheet['!cols'].push({ wch: ExcelFormattingTemplate.columnWidths.day });
  }

  sheet['!cols'].push({ wch: ExcelFormattingTemplate.columnWidths.labelTotal });
  sheet['!cols'].push({ wch: ExcelFormattingTemplate.columnWidths.valueTotal });

  console.log(`✅ Foglio template creato: ${lastRow} righe, ${lastColWithTotals} colonne`);
  return sheet;
};

export default ExcelFormattingTemplate;